import type { CreateSimplifiedExpenseInvoiceDto } from '../Types/expenseInvoice.types';
import type { SimplifiedExpenseInvoiceFormData } from '../Validation/simplifiedExpenseInvoiceValidation';

export const mapSimplifiedExpenseInvoiceFormDataToRequest = (
  data: SimplifiedExpenseInvoiceFormData
): CreateSimplifiedExpenseInvoiceDto => {
  if (data.companyId === null || data.totalGross === null) {
    throw new Error('Formularz kosztu uproszczonego jest niekompletny.');
  }

  return {
    companyId: data.companyId,
    issueDate: data.issueDate,
    totalGross: data.totalGross,
    currency: data.currency,
    description: data.description.trim(),
    tagIds: Array.from(new Set(data.tagIds)),
  };
};
